export { default } from "./ChangeTextValue";
